export default __webpack_public_path__ + "assets/icon-customers.0262cc35.webp";